import script from "./LightDarkSwtichBtn.vue?vue&type=script&lang=ts"
export * from "./LightDarkSwtichBtn.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__